import * as React from "react"
import {Grid, Typography} from "@mui/material";
import VideoPlayer from "../@components/VideoPlayer";


export default function InfoCenterPageContent({ title, video, text, poster, sx }) {
	return <Grid container spacing={2} sx={{ ml: 1, pb: 2, ...sx?.sxContainer }}>
		<Grid item xs={12}>
			<Typography variant="h4" sx={{mb: 1, fontWeight: 'bold'}}>
				{title}
			</Typography>
			<Typography variant="body1" sx={{mb: 1, fontWeight: 300}}>
				{text}
			</Typography>
		</Grid>
		<Grid item xs={4}>
			<VideoPlayer src={video} poster={poster} />
		</Grid>
		<Grid item xs={8} />
	</Grid>
}